var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M89.7647 78.678C96.8764 67.9339 97.6197 55.8732 92.6159 46.3664C87.864 37.3383 79.1164 34.5495 71.2331 28.785C54.0123 16.1927 46.5465 1.82287 26.5674 9.3032C11.2734 15.0294 5.65975 34.2319 4.23424 46.3664C2.80873 58.5008 7.77003 74.2959 18.4893 84.3801C27.581 92.9332 41.9316 97.0418 58.4036 94.8341C72.3064 92.9708 82.0224 90.3748 89.7647 78.678Z",
    fill: "white",
    fillOpacity: 0.87
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M89.7647 78.678C96.8764 67.9339 97.6197 55.8732 92.6159 46.3664C87.864 37.3383 79.1164 34.5495 71.2331 28.785C54.0123 16.1927 46.5465 1.82287 26.5674 9.3032C11.2734 15.0294 5.65975 34.2319 4.23424 46.3664C2.80873 58.5008 7.77003 74.2959 18.4893 84.3801C27.581 92.9332 41.9316 97.0418 58.4036 94.8341C72.3064 92.9708 82.0224 90.3748 89.7647 78.678Z",
    fill: "url(#paint0_linear_1086_32840)",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9739 76.6044L55.841 7.25H53.1258H48.1148H45.3997L25.2645 76.6044H13.1189V85.5807H88.1229V76.6044H75.9739Z",
    fill: "#ED6E19"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1095 45.428H34.3169L36.6381 37.4238H64.5988L67.1095 45.428Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3466 62.4524H70.086V54.4482H29.3466V62.4524Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0871 76.6054L50.7122 7.25195H55.224L75.9762 76.6054H70.0871Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4985 81.0083H87.5026V76.6055H12.4985V81.0083Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.996 84.3297H86.004V77.8545H75.3547C74.6649 77.8545 74.0607 77.4595 73.9001 76.8988L54.0433 8.49914H45.9578L26.1023 76.8988C25.9393 77.4595 25.3374 77.8545 24.6464 77.8545H13.996V84.3297ZM87.5026 86.8298H12.4974C11.6701 86.8298 11 86.2701 11 85.5803V76.6049C11 75.9151 11.6701 75.3544 12.4974 75.3544H23.4668L43.3224 6.95476C43.4853 6.39404 44.0872 6 44.7782 6H55.2241C55.9139 6 56.5182 6.39404 56.6788 6.95476L76.5344 75.3544H87.5026C88.331 75.3544 89 75.9151 89 76.6049V85.5803C89 86.2701 88.331 86.8298 87.5026 86.8298Z",
    fill: "#484848"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3678 77.8556H25.2667C24.4383 77.8556 23.7682 77.2968 23.7682 76.606C23.7682 75.9162 24.4383 75.3545 25.2667 75.3545H56.3678C57.1974 75.3545 57.8687 75.9162 57.8687 76.606C57.8687 77.2968 57.1974 77.8556 56.3678 77.8556Z",
    fill: "#484848"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8427 77.8556H65.1108C64.2847 77.8556 63.6111 77.2968 63.6111 76.606C63.6111 75.9162 64.2847 75.3545 65.1108 75.3545H82.8427C83.67 75.3545 84.3413 75.9162 84.3413 76.606C84.3413 77.2968 83.67 77.8556 82.8427 77.8556Z",
    fill: "#484848"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1086_32840",
    x1: 10.7586,
    y1: 4.84135,
    x2: 79.9267,
    y2: 82.996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#C8D7E9",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.189242,
    stopColor: "#C8D7E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#88A9D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#326BAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2864AA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCone);
export default __webpack_public_path__ + "static/media/cone.a86eab0f77c520751e49f694e580ea81.svg";
export { ForwardRef as ReactComponent };